import { currentEnvironment } from "@porsche-customer/slfinrtl-environment"
import type { CognitoClientOptions } from "src/types/CognitoClientOptions"

export function getCognitoConfig(): CognitoClientOptions {
	const host = window.location.host.split(".")
	const tld = host[host.length - 1]
	const environment = currentEnvironment()
	switch (environment) {
		case "prod":
			return {
				clientId: "3rtgq1d0f12est0742mgfqljab",
				host: "carsales-prod.auth.eu-central-1.amazoncognito.com",
				redirectUri: `https://dealer.finder.porsche.${tld}/`,
			}
		case "preview":
			return {
				clientId: "67rn3gm26kt3cgckl17jiffgjj",
				host: "carsales-preview.auth.eu-central-1.amazoncognito.com",
				redirectUri: `https://dealer.finder-preview.porsche.${tld}/`,
			}
		case "dev":
			return {
				clientId: "32ns0t0gtlqs92aghtrqhetvp7",
				host: "carsales-dev.auth.eu-central-1.amazoncognito.com",
				redirectUri: `https://dealer.finder-k.porsche.${tld}/`,
			}
		default:
			return {
				clientId: "32ns0t0gtlqs92aghtrqhetvp7",
				host: "carsales-dev.auth.eu-central-1.amazoncognito.com",
				redirectUri: "http://localhost:3000/",
			}
	}
}
